<template>
  <div class="login">
    <a-form ref="loginRef" :model="loginForm" :rules="loginRules" class="login-form">
      <div class="logo">
        <img src="@/assets/images/login-big.png" alt="">
      </div>
      <!-- <h3 class="title"><img src="../../assets/images/new-login-title.png" alt=""></h3> -->
      <!-- <h5 class="title">甘肃省低速无人驾驶车辆（装备）<br>测试示范服务平台</h5> -->
      <h3 class="title">甘肃省低速无人驾驶车辆（装备）<br>测试示范服务平台</h3>

      <a-form-item name ="username">
        <a-input
          v-model:value="loginForm.username"
          type="text"
          size="small"
          autocomplete="off"
          placeholder="账号"
        >
          <template #prefix><a-icon :type="userIcon" class="el-input__icon input-icon" /></template>
        </a-input>
      </a-form-item>
      <a-form-item name ="password">
        <a-input-password 
          v-model:value="loginForm.password"
          type="password"
          size="small"
          autocomplete="off"
          placeholder="密码"
          @keyup.enter="handleLogin"
        >
          <template #prefix><a-icon :type="passwordIcon" class="el-input__icon input-icon" /></template>
        </a-input-password >
      </a-form-item>
      <a-form-item name ="code" v-if="captchaEnabled">
        <a-input
          v-model:value="loginForm.code"
          size="small"
          autocomplete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter="handleLogin"
        >
          <template #prefix><a-icon :type="validCodeIcon" class="el-input__icon input-icon" /></template>
        </a-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </a-form-item>
      <!-- <a-checkbox v-model:value="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</a-checkbox> -->
      <a-form-item style="width:100%;">
        <a-button
          :loading="loading"
          size="large"
          type="primary"
          style="width:100%;margin-top:50px"
          @click.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </a-button>
        <div style="float: right;margin-top: 5px" v-if="register">
          <router-link class="link-type" :to="'/register'">立即注册</router-link>
        </div>
      </a-form-item>
      <br><br><br><br><br><br>
    </a-form>
    <!--  底部  -->
    <!-- <div class="el-login-footer">
      <span>版权所有 © 2018-2023 ruoyi.vip</span>
    </div> -->
  </div>
</template>

  <script setup>
  
  import { ref,getCurrentInstance,watch } from 'vue'
  import { useRoute,useRouter } from 'vue-router'
  import { getCodeImg } from "@/api/login";
  import Cookies from "js-cookie";
  import { encrypt, decrypt } from "@/utils/jsencrypt";
  import useUserStore from '@/store/modules/user'
  
  const userStore = useUserStore()
  const route = useRoute();
  const router = useRouter();
  const { proxy } = getCurrentInstance();
  const loginRef = ref();

  const loginForm = ref({
    username: "admin",
    password: "admin123",
    rememberMe: false,
    code: "",
    uuid: ""
  });
  
  const loginRules = {
    username: [{ required: true, trigger: "blur", message: "请输入您的账号" }],
    password: [{ required: true, trigger: "blur", message: "请输入您的密码" }],
    code: [{ required: true, trigger: "blur", message: "请输入验证码" }]
  };
  
  const codeUrl = ref("");
  const loading = ref(false);
  // 验证码开关
  const captchaEnabled = ref(true);
  // 注册开关
  const register = ref(true);
  const redirect = ref(undefined);
  
  watch(route, (newRoute) => {
      redirect.value = newRoute.query && newRoute.query.redirect;
  }, { immediate: true });

  function handleLogin() {

    loginRef.value
    .validate()
    .then(() => {
        loading.value = true;
        // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
        if (loginForm.value.rememberMe) {
          Cookies.set("username", loginForm.value.username, { expires: 30 });
          Cookies.set("password", encrypt(loginForm.value.password), { expires: 30 });
          Cookies.set("rememberMe", loginForm.value.rememberMe, { expires: 30 });
        } else {
          // 否则移除
          Cookies.remove("username");
          Cookies.remove("password");
          Cookies.remove("rememberMe");
        }
        // 调用action的登录方法
        userStore.login(loginForm.value).then((r) => {
          const query = route.query;
          const otherQueryParams = Object.keys(query).reduce((acc, cur) => {
            if (cur !== "redirect") {
              acc[cur] = query[cur];
            }
            return acc;
          }, {});
          //router.push({ path: redirect.value || "/home/index", query: otherQueryParams });
          router.push(r)
        }).catch(() => {
          loading.value = false;
          // 重新获取验证码
          if (captchaEnabled.value) {
            getCode();
          }
        });

    })
    .catch(error => {
      console.log('error', error);
    });

  }
  
  function getCode() {
    getCodeImg().then(res => {
      captchaEnabled.value = res.captchaEnabled === undefined ? true : res.captchaEnabled;
      if (captchaEnabled.value) {
        codeUrl.value = "data:image/gif;base64," + res.img;
        loginForm.value.uuid = res.uuid;
      }
    });
  }
  
  function getCookie() {
    const username = Cookies.get("username");
    const password = Cookies.get("password");
    const rememberMe = Cookies.get("rememberMe");
    loginForm.value = {
      username: username === undefined ? loginForm.value.username : username,
      password: password === undefined ? loginForm.value.password : decrypt(password),
      rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
    };
  }
  
  getCode();
  getCookie();
  </script>
  
  <style lang='scss' scoped>
  .login {
    display: flex;
    justify-content: end;
    align-items: center;
    height: 100%;
    background-size: 100% 100%;
    background-image: url('../../assets/images/login.png');
    padding-right: 6%;
  }
  .logo{
    text-align: center;
    padding:48px 0 21px 0;
    
    img{
      width: 59px;
    }
  }
  .title {
    margin: 0px auto 30px auto;
    text-align: center;
    font-size: 26px;
    font-weight: 500;
    color: #ffffff;
    font-family: DingTalk;
    line-height: 1.5;
    word-break: break-all;
  }
  
  .login-form {
    border-radius: 20px;
    background: url('../../assets/images/login-box.png') center no-repeat;
    padding: 25px 40px 5px 40px;
    .el-input {
      height: 40px;
      input {
        height: 40px;
      }
    }
    .input-icon {
      height: 39px;
      width: 14px;
      margin-left: 0px;
    }
    label{
      color: rgba(85, 85, 85, 1);
      font-weight: 400;
    }
  }
  .login-tip {
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
  }
  .login-code {
    width: 33%;
    height: 40px;
    float: right;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
  }
  .login-code-img {
    height: 40px;
    padding-left: 12px;
  }
  </style>
  